import { catchError, filter, map } from 'rxjs/operators';
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable, Subscription, throwError } from 'rxjs';

import { AbstractFormComponent } from '../../../shared/crud/component/form.component';
import { CampaignId } from '../../campaign-util/shared/campaign-id';
import { EventBus } from '../../../shared/event/bus';
import { ICrudForm } from '../../../shared/crud/form/crud-form.interface';
import { UrlBuilder } from '../../../shared/crud/api/url-builder';

export abstract class AbstractPresetFormComponent extends AbstractFormComponent implements OnInit, AfterViewInit, OnDestroy {

  protected routeChangeSubscription: Subscription;

  constructor(formBuilder: ICrudForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              urlBuilder: UrlBuilder,
              router: Router,
              route: ActivatedRoute,
              protected campaignId: CampaignId,
              protected eventBus: EventBus) {
    super(formBuilder, httpClient, toastrService, router, route, urlBuilder);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.routeChangeSubscription = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.route))
      .subscribe((event: any) => {
        if (event.url && event.url._value && event.url.value[0]) {
          const id = event.url._value[0].path;
          this.loadingPromise = this.populate(id).subscribe();
        }
      });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.routeChangeSubscription) {
      this.routeChangeSubscription.unsubscribe();
    }
    this.eventBus.release();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();

    if (this.formMode === 'update') {
      this.loadingPromise = this.populate().subscribe();
    }
  }

  populate(forceId?: number): Observable<any> {
    this.eventBus.emit('preset:loading', true);
    return super.populate(forceId).pipe(
      map(
        (response: any) => {
          this.eventBus.emit('preset:loading', false);
          return response;
        }
      ),
      catchError((error: any) => {
        this.eventBus.emit('preset:loading', false);
        return throwError(error);
      }));
  }

  protected onSubmit(response: any): void {
    this.toastrService.success('Saved');
    this.eventBus.emit('preset:saved');
  }
}
